import styled from 'styled-components';

export const Message = styled.p`
  font: var(--font-32);
  color: var(--color-red);
  text-align: center;
  margin: 1em;
`;
